import request from "./request";

export const getUserDetail = (id: string) =>
  request(`/admin/users/${id}`, {
    method: 'GET',
  })
